import * as React from 'react'
import RadioElements from './Elements'

export default function AppRadioButton({ title='', items, value, onChange }) {


    return <div className="switch-field switch-table-prices flex flex-middle">
        <div className="switch-title">{title}</div>
        {items.map((item, id) => {
            return <RadioElements item={item} key={`${id}-${item?.value}`} id={`${id}-${item?.value}`} onChange={onChange} value={value} />
        })}
    </div>
}